import React, { Component } from "react";
import { observer } from "mobx-react";
import "./ProgressBar.scss";

class ProgressBar extends Component {
  render() {
    const props = this.props;
    return (
      <div className="progress-bar component">
        <div className="progress" style={{ width: `${this.percentage}%` }} />
        {this.percentage}%
        {props.label ? (
          <span className="count">
            {props.label
              .replace("%1", props.complete)
              .replace("%2", props.total)}
          </span>
        ) : null}
      </div>
    );
  }

  get percentage() {
    // // mock
    // return Math.round(Math.random() * 100);
    const props = this.props;
    const percentage = Math.round(
      100 * Math.min(props.complete / props.total, 1),
    );

    return percentage || 0;
  }
}

export default observer(ProgressBar);
